var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import resolveBackgroundColor from '../propertyGroups/backgroundColor/BackgroundColorResolver';
import resolveBorder from '../propertyGroups/border/BorderResolver';
import resolveCircle from '../propertyGroups/circle/CircleResolver';
import resolveColor from '../propertyGroups/color/ColorResolver';
import resolveFlex from '../propertyGroups/flex/FlexResolver';
import resolveFont from '../propertyGroups/font/FontResolver';
import resolveHeight from '../propertyGroups/height/HeightResolver';
import resolveMargin from '../propertyGroups/margin/MarginResolver';
import resolveOpacity from '../propertyGroups/opacity/OpacityResolver';
import resolveOverflow from '../propertyGroups/overflow/OverflowResolver';
import resolvePadding from '../propertyGroups/padding/PaddingResolver';
import resolvePosition from '../propertyGroups/position/PositionResolver';
import resolveTextAlign from '../propertyGroups/textAlign/TextAlignResolver';
import resolveWidth from '../propertyGroups/width/WidthResolver';
import resolveZIndex from '../propertyGroups/zIndex/ZIndexResolver';
export default function resolveStyleObject(theme, themeVariation, screenWidth, propertyGroups) {
    var styleObjects = propertyGroups.map(function (propertyGroup) {
        switch (propertyGroup) {
            case 'border':
                return resolveBorder(theme, screenWidth, themeVariation);
            case 'backgroundColor':
                return resolveBackgroundColor(theme, screenWidth, themeVariation);
            case 'circle':
                return resolveCircle(theme, screenWidth, themeVariation);
            case 'color':
                return resolveColor(theme, screenWidth, themeVariation);
            case 'flex':
                return resolveFlex(theme, screenWidth, themeVariation);
            case 'font':
                return resolveFont(theme, screenWidth, themeVariation);
            case 'height':
                return resolveHeight(theme, screenWidth, themeVariation);
            case 'margin':
                return resolveMargin(theme, screenWidth, themeVariation);
            case 'opacity':
                return resolveOpacity(theme, screenWidth, themeVariation);
            case 'padding':
                return resolvePadding(theme, screenWidth, themeVariation);
            case 'position':
                return resolvePosition(theme, screenWidth, themeVariation);
            case 'textAlign':
                return resolveTextAlign(theme, screenWidth, themeVariation);
            case 'width':
                return resolveWidth(theme, screenWidth, themeVariation);
            case 'zIndex':
                return resolveZIndex(theme, screenWidth, themeVariation);
            case 'overflow':
                return resolveOverflow(theme, screenWidth, themeVariation);
            default:
                return {};
        }
    });
    var result = {};
    styleObjects.forEach(function (x) {
        result = __assign(__assign({}, result), x);
    });
    return result;
}
//# sourceMappingURL=StyleObjectResolver.js.map